import * as Sentry from '@sentry/react'

const sentryDsn = process.env.REACT_APP_SENTRY_DSN

const getSentryConfig = () => ({
  org: process.env.SENTRY_ORG,
  project: process.env.SENTRY_PROJECT,
  dsn: sentryDsn,
  authToken: process.env.SENTRY_AUTH_TOKEN,
  environment: process.env.REACT_APP_SENTRY_ENV || 'develop',
  release: process.env.REACT_APP_SENTRY_RELEASE,

  widenClientFileUpload: true,
  disableLogger: true,
  autoSessionTracking: true, // Crash Free Sessions
  sendDefaultPii: true, // 기본 개인정보(IP, User-Agent 등) 전송

  reactComponentAnnotation: {
    enabled: true,
    automaticVercelMonitors: true,
  }, // 에러 스택에 React 컴포넌트 이름 표시
  integrations: [
    Sentry.browserTracingIntegration({
      enableLongTask: true,
      enableInp: true, // Interaction to Next Paint (INP)
    }), // 페이지 로드 / API / 라우팅 성능 추적

    Sentry.browserProfilingIntegration(),

    Sentry.replayIntegration({
      maskAllText: true, // 텍스트 마스킹
      blockAllMedia: true, // 미디어 차단
      networkDetailAllowUrls: [window.location.origin],
      networkCaptureBodies: true,
    }),
  ],
  // tracePropagationTargets: ['localhost', 'dev.safepassword.jp'],
  // tracesSampleRate: 1.0,
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'console') {
      return null
    }
    return breadcrumb
  },

  maxBreadcrumbs: 50,
  attachStacktrace: true,
  sendClientReports: true, // 전송 실패 / rate limit 리포트

  profilesSampleRate: 0.1,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  enableLogs: true, // Sentry Logs 기능 활성화
})

let initedSentry = false

export const initSentry = () => {
  if (sentryDsn) {
    Sentry.init(getSentryConfig())
    initedSentry = true
  } else {
    console.warn('Sentry is disabled because REACT_APP_SENTRY_DSN is not set')
  }
}

// initSentry()

export const sentrySetUser = (email, id) => {
  if (initedSentry === false || email == null || email.length === 0) {
    return
  }

  Sentry.setUser({
    id: id || email,
    email,
  })
}
